(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-form.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/receiver/components/search-form.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.ticketsOrderHome.utils.logger;
const {
  useOrderHomeContext
} = svs.ticketsOrderHome.context;
const {
  searchReceiversAsync
} = svs.ticketsOrderHome.services;
const {
  Loader
} = svs.ticketsOrderHome.components;
const {
  TextInput
} = svs.ui.reactFormInputs;
const {
  Form
} = svs.ui.reactForm;
const {
  ReactButton: Button,
  ReactIcon: Icon
} = svs.ui;
const {
  Fragment,
  useState
} = React;
const {
  characterValidator
} = svs.ticketsOrderHome.utils;
const {
  NO_SEARCH_RESULTS,
  INPUT_VALIDATION_FAILED,
  TOO_MANY_SEARCH_RESULTS
} = svs.ticketsOrderHome.utils.constants.orderHomeReceiver.errors;
const SearchForm = () => {
  var _receiver$search, _receiver$search$fnam, _receiver$search2, _receiver$search$lnam, _receiver$search3, _receiver$search$stre, _receiver$search4, _receiver$search$city, _receiver$search5;
  const {
    state: {
      receiver
    },
    setReceiver,
    setReceiverSearchResult
  } = useOrderHomeContext();
  const [loading, setLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const {
    fname,
    lname,
    street,
    city
  } = (_receiver$search = receiver.search) !== null && _receiver$search !== void 0 ? _receiver$search : {};
  const validateFn = value => {
    if (!characterValidator(value)) {
      return {
        isValid: false,
        errorMessage: 'Texten innehåller otillåtna tecken.'
      };
    }
    return {
      isValid: true
    };
  };
  const handleChangeSearch = _ref => {
    let {
      target: {
        name,
        value
      }
    } = _ref;
    setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
      search: _objectSpread(_objectSpread({}, receiver.search), {}, {
        [name]: value
      })
    }));
  };
  const handleSubmitSearch = async (e, formData) => {
    var _receiver$results, _receiver$results$len, _receiver$results2;
    e.preventDefault();
    const invalidInputs = Object.entries(formData).filter(_ref2 => {
      let [, {
        isValid
      }] = _ref2;
      return !isValid;
    }).map(_ref3 => {
      let [name] = _ref3;
      return name;
    });
    if (invalidInputs.length > 0) {
      logger.info('Failed validation of inputs when searching for receiver', invalidInputs);
      return;
    }
    setSearchError(null);
    setLoading(true);
    const searchCacheKey = "".concat(fname, ",").concat(lname, ",").concat(street, ",").concat(city).toLowerCase();
    const searchCacheValue = (_receiver$results = receiver.results) === null || _receiver$results === void 0 ? void 0 : _receiver$results[searchCacheKey];
    if (searchCacheValue !== null && searchCacheValue !== void 0 && searchCacheValue.result) {
      setReceiver(_objectSpread(_objectSpread({}, receiver), {}, {
        result: searchCacheValue.result
      }));
      return;
    }
    if (searchCacheValue !== null && searchCacheValue !== void 0 && searchCacheValue.error) {
      setLoading(false);
      setSearchError(searchCacheValue.error);
      return;
    }
    logger.info("Searching for receiver with ".concat((_receiver$results$len = (_receiver$results2 = receiver.results) === null || _receiver$results2 === void 0 ? void 0 : _receiver$results2.length) !== null && _receiver$results$len !== void 0 ? _receiver$results$len : 0, " queries in cache"));
    const {
      result,
      error
    } = (await searchReceiversAsync({
      firstName: fname,
      lastName: lname,
      street,
      city,
      receiver
    })) || {};
    if (error) {
      setLoading(false);
      switch (error.code) {
        case NO_SEARCH_RESULTS.code:
        case TOO_MANY_SEARCH_RESULTS.code:
        case INPUT_VALIDATION_FAILED.code:
          setReceiverSearchResult(searchCacheKey, {
            error: error.message
          });
          setSearchError(error.message);
          break;
        default:
          setSearchError(error.message);
      }
      return;
    }
    if (result && result.length > 0) {
      var _receiver$results$len2, _receiver$results3;
      logger.info("Search call ".concat(((_receiver$results$len2 = (_receiver$results3 = receiver.results) === null || _receiver$results3 === void 0 ? void 0 : _receiver$results3.length) !== null && _receiver$results$len2 !== void 0 ? _receiver$results$len2 : 0) + 1, " returned ").concat(result.length, " results"));
      setReceiverSearchResult(searchCacheKey, {
        result
      });
    }
  };
  return React.createElement(Fragment, null, loading && React.createElement(Loader, null), searchError && React.createElement("div", null, React.createElement("h4", {
    className: "h4 fw-500 padding-bottom-2 border-bottom"
  }, "S\xF6kresultat"), React.createElement("div", {
    className: "border-bottom padding-bottom-2 margin-bottom-3 u-flex"
  }, React.createElement(Icon, {
    className: "margin-right-1 search-error-icon",
    color: "fc-red",
    icon: "exclamation-sign",
    size: "300"
  }), React.createElement("span", null, searchError))), React.createElement("h4", {
    className: "h4 fw-500 margin-bottom-half"
  }, "S\xF6k efter mottagare"), React.createElement(Form, {
    onSubmit: handleSubmitSearch
  }, React.createElement(TextInput, {
    autoComplete: "off",
    isLessSpace: true,
    isRequired: true,
    label: "F\xF6rnamn*",
    min: 2,
    name: "fname",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$fnam = (_receiver$search2 = receiver.search) === null || _receiver$search2 === void 0 ? void 0 : _receiver$search2.fname) !== null && _receiver$search$fnam !== void 0 ? _receiver$search$fnam : ''
  }), React.createElement(TextInput, {
    autoComplete: "off",
    isRequired: true,
    label: "Efternamn*",
    min: 2,
    name: "lname",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$lnam = (_receiver$search3 = receiver.search) === null || _receiver$search3 === void 0 ? void 0 : _receiver$search3.lname) !== null && _receiver$search$lnam !== void 0 ? _receiver$search$lnam : ''
  }), React.createElement(TextInput, {
    autoComplete: "off",
    isRequired: false,
    label: "Gata",
    name: "street",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$stre = (_receiver$search4 = receiver.search) === null || _receiver$search4 === void 0 ? void 0 : _receiver$search4.street) !== null && _receiver$search$stre !== void 0 ? _receiver$search$stre : ''
  }), React.createElement(TextInput, {
    autoComplete: "off",
    isRequired: true,
    label: "Postort*",
    name: "city",
    onChange: handleChangeSearch,
    validateFn: validateFn,
    value: (_receiver$search$city = (_receiver$search5 = receiver.search) === null || _receiver$search5 === void 0 ? void 0 : _receiver$search5.city) !== null && _receiver$search$city !== void 0 ? _receiver$search$city : ''
  }), React.createElement(Button, {
    block: true,
    className: "margin-v-2",
    iconPosition: "center",
    inverted: true,
    type: "submit"
  }, React.createElement(Icon, {
    icon: "search"
  }), "S\xF6k")));
};
setGlobal('svs.ticketsOrderHome.orderHome.receiver.components.SearchForm', SearchForm);

 })(window);